import React, { useState } from 'react';

export default function Puppeteer() {
  const [url, setUrl] = useState('http://localhost:5176/hook-machine');
  const [screenshot, setScreenshot] = useState('');
  const [loading, setLoading] = useState(false);

  const takeScreenshot = async () => {
    setLoading(true);
    try {
      const response = await fetch('http://localhost:3001/api/screenshot', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ url })
      });
      const data = await response.json();
      setScreenshot(data.screenshot); // base64 image

      if (data.hasMarker) {
        console.log('✅ TEST-PASS marker detected!');
      }
    } catch (error) {
      console.error('Failed to take screenshot:', error);
    }
    setLoading(false);
  };

  return (
    <div className="p-8 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Puppeteer Screenshot</h1>

      <div className="flex gap-2 mb-4">
        <input
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          className="flex-1 px-4 py-2 border rounded bg-gray-800 text-white"
          placeholder="Enter URL to screenshot"
        />
        <button
          onClick={takeScreenshot}
          disabled={loading}
          className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? 'Taking...' : 'Screenshot'}
        </button>
      </div>

      {screenshot && (
        <div className="border-2 border-gray-700 rounded p-4">
          <img src={`data:image/png;base64,${screenshot}`} alt="Screenshot" className="w-full" />
        </div>
      )}
    </div>
  );
}